import React, { useRef, useState } from 'react';
import { read, utils } from 'xlsx';

// Define required columns


interface ValidationError {
  message: string;
  missingColumns?: string[];
}

const ReadExcel = (file: File, requiredColumns?: string[]): Promise<{ data: (string)[][], error?: ValidationError }> => {
  return new Promise((resolve, reject) => {
    if (file) {
      const reader = new FileReader();

      reader.onload = function (e: ProgressEvent<FileReader>) {
        try {
          const data = e.target?.result;
          if (data instanceof ArrayBuffer) {
            const workbook = read(data, { type: 'array' });

            // Assuming there is only one sheet in the workbook
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            // Convert the sheet to JSON
            const jsonData = utils.sheet_to_json(sheet, { header: 1 }) as (string)[][];
            // Validate headers (assuming first row contains headers)
            if (jsonData.length === 0) {
              resolve({
                data: [],
                error: { message: 'Excel file is empty' }
              });
              return;
            }

            const headers = jsonData[0].map(header =>
              typeof header === 'string' ? header.toLowerCase().trim() : ''
            );

            // Check for missing required columns
            const missingColumns = requiredColumns ? requiredColumns.filter(
              col => !headers.includes(col.toLowerCase())
            ): [];

            if (missingColumns.length > 0) {
              resolve({
                data: jsonData,
                error: {
                  message: `Missing required columns: ${missingColumns.join(', ')}`,
                  missingColumns
                }
              });
              return;
            }


            resolve({ data: jsonData }); // Resolve with valid data
          } else {
            resolve({
              data: [],
              error: { message: 'Invalid file data' }
            });
          }
        } catch (error) {
          resolve({
            data: [],
            error: { message: error instanceof Error ? error.message : 'Unknown error occurred' }
          });
        }
      };

      reader.onerror = function () {
        resolve({
          data: [],
          error: { message: 'File could not be read' }
        });
      };

      reader.readAsArrayBuffer(file);
    } else {
      resolve({
        data: [],
        error: { message: 'No file provided' }
      });
    }
  });
};

export default ReadExcel;
